import { useState } from "react";
import { Button, Form, InputGroup } from "react-bootstrap";
import { FaSearch } from "react-icons/fa";
import { filterDataByQuery } from "../../utils/filterDataByQuery";

interface IProps<T> {
  data: T[]; // lista original
  placeholder?: string;
  setData: React.Dispatch<React.SetStateAction<T[]>>; // lista filtrada
}

const FilterComp = <T extends object>({
  data,
  placeholder = "Pesquisar...",
  setData,
}: IProps<T>) => {
  const [query, setQuery] = useState("");

  const handleFilter = (text: string) => {
    setQuery(text);

    if (text.trim() === "") {
      setData([...data]); // reset com cópia dos dados originais
      return;
    }

    const filtered = filterDataByQuery(data, text);
    setData(filtered);
  };

  const clearFilter = () => {
    setQuery("");
    setData([...data]); // reseta para a lista original
  };

  return (
    <div className="my-3">
      <InputGroup>
        <InputGroup.Text>
          <FaSearch />
        </InputGroup.Text>
        <Form.Control
          value={query}
          onChange={(e) => handleFilter(e.target.value)}
          placeholder={placeholder}
        />
        {query && (
          <Button variant="outline-danger" onClick={clearFilter}>
            Limpar
          </Button>
        )}
      </InputGroup>
    </div>
  );
};

export default FilterComp;
